// extracted by mini-css-extract-plugin
module.exports = {"Panel":"css-modules_Panel__6IJi1","Button":"css-modules_Button__V_w6Z"};